<template>
  <page>
    <lazy-div :load="doInit">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newShortTermRate">mdi-plus</v-icon>
          <v-icon v-else-if="reviewShortTermRate">mdi-pencil</v-icon>
          <v-icon v-else-if="queryShortTermRate">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newShortTermRate">Create New Short Term Rate</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewShortTermRate">Edit Short Term Rate</v-toolbar-title>
          <v-toolbar-title v-else-if="queryShortTermRate">Query Short Term Rate</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          {{ strMode }}
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6>
                <v-text-field
                  :readonly="queryShortTermRate"
                  v-model="shortTermRateForm.shortTermPct"
                  :label="shortTermRateLabel.shortTermPct"
                  :error-messages="errors.collect('shortTermRateForm.shortTermPct')"
                  v-num-mask="{ negative: true, intScale: 3, decScale: 2 }"
                  data-vv-name="shortTermRateForm.shortTermPct"
                  :data-vv-as="shortTermRateLabel.shortTermPct"
                  v-validate="'mask_max_value:100'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="poltype"
                  v-model="shortTermRateForm.polType"
                  item-text="label"
                  item-value="value"
                  :label="shortTermRateLabel.polType"
                  :error-messages="errors.collect('polType')"
                  :readonly="reviewShortTermRate || queryShortTermRate"
                  data-vv-name="polType"
                  :data-vv-as="shortTermRateLabel.polType"
                  v-validate="'entry|param|max:4'"
                  :clearable="newShortTermRate"
                >
                </v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="appDayMthList"
                  v-model="shortTermRateForm.appDayMth"
                  :readonly="reviewShortTermRate || queryShortTermRate"
                  :label="shortTermRateLabel.appDayMth"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('appDayMth')"
                  data-vv-name="appDayMth"
                  :data-vv-as="shortTermRateLabel.appDayMth"
                  :clearable="newShortTermRate"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                  v-model="shortTermRateForm.noDayMth"
                  :label="shortTermRateLabel.noDayMth"
                  :readonly="reviewShortTermRate || queryShortTermRate"
                  :error-messages="errors.collect('noDayMth')"
                  data-vv-name="noDayMth"
                  :data-vv-as="shortTermRateLabel.noDayMth"
                  v-validate="noDayMthValidtion"
                  @blur="setZero()"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ shortTermRateLabel.createdName }}</v-subheader>
                <div class="queryValue">{{ shortTermRateForm.createdName }}</div>
              </v-flex>
              <v-flex xs6>
                <v-subheader class="queryLabel">{{ shortTermRateLabel.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(shortTermRateForm.createdDate) }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newShortTermRate">
                <v-subheader class="queryLabel">{{ shortTermRateLabel.modifiedName }}</v-subheader>
                <div class="queryValue">{{ shortTermRateForm.modifiedName }}</div>
              </v-flex>
              <v-flex xs6 v-if="!newShortTermRate">
                <v-subheader class="queryLabel">{{ shortTermRateLabel.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(shortTermRateForm.modifiedDate) }}</div>
              </v-flex>
            </v-layout>
            <v-spacer class="mt-3"></v-spacer>
            <v-layout>
              <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
                <span>Cancel</span>
                <v-icon right dark>mdi-cancel</v-icon>
              </v-btn>
              <v-btn color="primary" v-if="!queryShortTermRate" dark class="mr-2" @click="doSave" :loading="submitting">
                Save
                <v-icon right>mdi-content-save</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      poltype: [],
      submitting: false,
      shortTermRateLabel: {
        shortTermPct: 'Short Term Rate',
        polType: 'Policy Type',
        appDayMth: 'Apply / Day Month',
        noDayMth: 'No. Days / Months',
        createdName: 'Created By',
        createdDate: 'Created Date',
        modifiedName: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      shortTermRateForm: {
        shortTermPct: '0.00',
        polType: '',
        appDayMth: null,
        noDayMth: '0',
        createdName: null,
        createdDate: null,
        modifiedName: null,
        modifiedDate: null
      },
      appDayMthList: [
        { label: 'Day', value: 'D' },
        { label: 'Month', value: 'M' }
      ]
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('poltype')
      if (this.newShortTermRate) {
        this.shortTermRateForm.appDayMth = 'M'
        this.shortTermRateForm.effDate = new Date()
        this.shortTermRateForm.createdName = this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName
        this.shortTermRateForm.createdDate = new Date()
      } else {
        this.shortTermRateForm.shortTermPct = this.shortTermRateId.shortTermPct
        this.shortTermRateForm.polType = this.shortTermRateId.polType
        this.shortTermRateForm.appDayMth = this.shortTermRateId.appDayMth
        this.shortTermRateForm.noDayMth = this.shortTermRateId.noDayMth
        this.shortTermRateForm.createdName = this.shortTermRateId.createdName
        this.shortTermRateForm.createdDate = this.shortTermRateId.createdDate
        this.shortTermRateForm.modifiedName = this.shortTermRateId.modifiedName
        this.shortTermRateForm.modifiedDate = this.shortTermRateId.modifiedDate
      }
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newShortTermRate) {
            this.doCreate()
          } else if (this.reviewShortTermRate) {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doCreate() {
      const apiURI = this.menu.createShortTermRate
      if (apiURI) {
        this.shortTermRateForm.rate = this.shortTermRateForm.shortTermPct
        this.$http
          .post(apiURI, this.shortTermRateForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$router.push({ name: 'shrtTrmRate' })
              this.notify(data)
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    doUpdate() {
      const apiURI = this.menu.updateShortTermRate
      if (apiURI) {
        this.shortTermRateForm.rate = this.shortTermRateForm.shortTermPct
        this.$http
          .put(apiURI, this.shortTermRateForm)
          .then((result) => {
            const { data } = result
            if (data) {
              this.$router.push({ name: 'shrtTrmRate' })
              this.notify(data)
            }
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    },
    setZero() {
      if (this.shortTermRateForm.noDayMth === '') {
        this.shortTermRateForm.noDayMth = '0'
      }
    },
    doCancel() {
      this.$router.push({ name: 'shrtTrmRate' })
    }
  },
  created() {
    const jsonData = JSON.parse(sessionStorage.getItem('shrtTrmRate'))
    this.$store.commit('SHORTTERMRATE_COMMIT_KEY', jsonData)

    this.$validator.extend('valNoMth', {
      getMessage(field, args) {
        return 'Month cannot exceed 12'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var noDayMth = args[0]
        if (noDayMth) {
          if (parseInt(value) > noDayMth) {
            return false
          } else {
            return true
          }
        }
      }
    })

    this.$validator.extend('valNoDay', {
      getMessage(field, args) {
        return 'Day cannot exceed 366'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var noDayMth = args[0]
        if (noDayMth) {
          if (parseInt(value) > noDayMth) {
            return false
          } else {
            return true
          }
        }
      }
    })
  },
  computed: {
    menu() {
      return this.$store.state.shortTermRateParam.menu
    },
    newShortTermRate() {
      return this.shortTermRateId.strMode === 'New'
    },
    reviewShortTermRate() {
      return this.shortTermRateId.strMode === 'Review'
    },
    queryShortTermRate() {
      return this.shortTermRateId.strMode === 'Query'
    },
    shortTermRateId() {
      return this.$store.state.shortTermRateParam.shortTermRate.shortTermRateId
    },
    noDayMthValidtion() {
      if (this.shortTermRateForm.appDayMth === 'M') {
        return 'valNoMth:' + '12'
      } else {
        return 'valNoDay:' + '366'
      }
    },
    strMode() {
      return this.$route.params.strMode
    }
  },
  mixins: [MessageMixin, commonAjaxMixin]
}
</script>

<style>
</style>
